import type { EventName } from "@lit/react";
import { Checkbox as CheckboxElement, type CheckboxEventMap as _CheckboxEventMap, } from "@vaadin/checkbox/vaadin-checkbox.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { CheckboxElement, };
export type CheckboxEventMap = Readonly<{
    onValidated: EventName<_CheckboxEventMap["validated"]>;
    onChange: EventName<_CheckboxEventMap["change"]>;
    onCheckedChanged: EventName<_CheckboxEventMap["checked-changed"]>;
    onInvalidChanged: EventName<_CheckboxEventMap["invalid-changed"]>;
    onIndeterminateChanged: EventName<_CheckboxEventMap["indeterminate-changed"]>;
}>;
const events = { onValidated: "validated", onChange: "change", onCheckedChanged: "checked-changed", onInvalidChanged: "invalid-changed", onIndeterminateChanged: "indeterminate-changed" } as CheckboxEventMap;
export type CheckboxProps = WebComponentProps<CheckboxElement, CheckboxEventMap>;
export const Checkbox = createComponent({
    elementClass: CheckboxElement, events, react: React, tagName: "vaadin-checkbox"
});
